import { AppHelper } from "../../appHelper";
import { AppBaseProps, CommonApp } from "../../core/components/commonApp";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { DocumentFolderStructure } from "../../documents/documents";
import EditTranslationsInGrid from "../editTranslationsInGrid";
import React from "react";
export interface EditDocumentFolderStructureTreeItemProps extends AppBaseProps {
    entity: DocumentFolderStructure;
}

export default class EditDocumentFolderStructureTreeItem extends React.Component<EditDocumentFolderStructureTreeItemProps, {
}>{
    private common = new AppHelper();
    private translationInGridRef: EditTranslationsInGrid;

    constructor(props) {
        super(props);
        this.common.init(this);
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit) {
            this.common.handleFieldChange(field, value, dataItem);
        }
    }

    save = async (closeAfterSave) => {
        var result = await HTTPService.post<JsonResultClass>("GeneralSettingsDocumentsFolderStructure/SaveFolderStructureItem", this.props.entity);
        if (result.Code == 0) {
            this.common.setEntityDirtyState(false);
            this.props.entity.IsNew = false;
            this.setState({});
            this.translationInGridRef.markAsSaved();
            NotificationHelper.showSuccessMessage(result.Message);
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    renderEditTranslationsInGrid = () => {
        let translationColumns = [
            {
                visible: true,
                width: "100",
                field: "Translation",
                title: Helper.getTranslation("Standard.Name")
            }
        ];

        return <EditTranslationsInGrid
            id={"editDocumentFolderStructureTranslationsInGrid"}
            gridData={this.props.entity.Translations}
            translationColumns={translationColumns}
            setEntityDirtyState={(isDirty) => this.common.setEntityDirtyState(isDirty)}
            ref={(ref) => this.translationInGridRef = ref} />
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}